fx.ns("filters", class SortPhotosByPerson extends fx.Filter {

	constructor(guests)
	{
		super();	
		this.label = fx.text("Personne");
        this.guests = guests;
	}

	get photosused()
	{
		return this._photosused;
	}

	set photosused(val)
	{
		this._photosused = val;

		this.refresh();

		this.trigger("updated");
	}
	
	
	exec()
	{
		if (!this.rawData) return;
		
		let photos = this.rawData;

		// sort pictures chronologically
		photos = photos.sort( this.sort );
		photos = photos.filter(this._filterPhotos, this );
		
		// calculate average
		let ret = [], guestname1 = "", guestname2 = "", sameName = false;
		for(let i = 0; i < photos.length; i++)
		{
			if (photos[i].deleted)
				continue;

			// skip shared photos which have not been validated
			if (photos[i].labels == "share-uploader" && photos[i].validated == 0 && photos[i].guestid)
				continue;

			if (!this.photosused && photos[i].number > 0)
				continue;
				
			for(let j = 0; j < this.guests.length; j++)
			{
				if (this.guests.getItemAt(j).id == photos[i].guestid)
				{
					guestname2 = this.guests.getItemAt(j).name;
					break;
				}
			}
			if (!guestname2)
				continue;
			if (i == 0)
			{
				sameName = false;
			}
			else
			{
				for(let j = 0; j < this.guests.length; j++)
				{
					if (this.guests.getItemAt(j).id == photos[i-1].guestid)
						guestname1 = this.guests.getItemAt(j).name;
					if (this.guests.getItemAt(j).id == photos[i].guestid)
						guestname2 = this.guests.getItemAt(j).name;
				}
				sameName = (guestname1 == guestname2) ;
			}
			if (!sameName)
				ret.push( {type : "label", text : guestname2} );	

			ret.push(photos[i]);

		}
		return ret;
	}

	sort(item1, item2)
	{
		
		let guestname1 = "";
		let guestname2 = "";
		for(let i = 0; i < this.guests.length; i++)
		{
			if (this.guests.getItemAt(i).id == item1.guestid)
				guestname1 = this.guests.getItemAt(i).name;
			if (this.guests.getItemAt(i).id == item2.guestid)
				guestname2 = this.guests.getItemAt(i).name;
		}

		if (guestname1 > guestname2)
			return 1;
		if (guestname1 < guestname2)
			return -1;
		else
			return 0
	}

	_filterPhotos(photo)
	{
		if ( !this.photosused && photo.number > 0)
			return false;

		return !photo.deleted;
	}
	
});
